import React from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';

interface Props {
    links: any[];
    title?: string;
}

const hasTrackingUrl = (link: any) => {
    return link && link.trackinglink && String(link.trackinglink).trim() !== '';
};

export const TrackingLinksOverview: React.FC<Props> = (props) => {
    const { links, title } = props;
    const validLinks = (links || []).filter(hasTrackingUrl);

    if (!validLinks.length) {
        return (
            <div className="h-full flex justify-center pt-16 px-4">
                <h1 className="text-2xl">No tracking links available for this shipment.</h1>
            </div>
        );
    }

    return (
        <div className="tracking-links-overview p-4">
            <h2 className="text-xl mb-4">{title || 'Tracking links'}</h2>
            <p className="mb-4 text-sm">Click a link to open carrier tracking in a new tab.</p>
            <table className="striped-table table-fixed table-hover completed-orders-table text-xs w-full">
                <thead>
                    <tr>
                        <th style={{ width: '80px' }}>Parcel</th>
                        <th>Tracking number</th>
                        <th style={{ width: '140px' }}></th>
                    </tr>
                </thead>
                <tbody>
                    {validLinks.map((link: any, index: number) => {
                        const url = String(link.trackinglink).trim();
                        return (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{link.parcelno || '—'}</td>
                                <td>
                                    <a
                                        href={url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="to__button"
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        Open tracking
                                        <span className="ml-2 icon"><FaExternalLinkAlt /></span>
                                    </a>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default TrackingLinksOverview;
